<template>
  <div class="booking-flow-shell">
    <header-component :bookingHeaderColor="'bookingapp'" />
    <v-container fluid class="booking-flow-page booking-flow-shell__content">
      <v-row justify="center">
        <v-col cols="12" class="mobileResBlock">
          <div class="summary-page-window">
          <!-- OLD FLOW (disabled): Order Summary / Contact / Details stepper
          <div
            v-show="disableORenable2ndDetailPage == true"
            class="stepper-wrapper"
          >
            <div class="stepper-item completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Order Summary</div>
            </div>

            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Contact</div>
            </div>

            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Details</div>
            </div>

            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Summary</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Payment</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name">Billing Summary</div>
            </div>
          </div>
          <div
            v-show="disableORenable2ndDetailPage == false"
            class="stepper-wrapper"
          >
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Order Summary</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Contact</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Summary</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Payment</div>
            </div>
            <div class="stepper-itemEnabled completed">
              <div class="step-counter">
                <TickMark />
              </div>
              <div class="step-name fontsize">Billing Summary</div>
            </div>
          </div>
          -->

              <h2 v-if="!bookingConfirmed" class="summaryHead">Summary</h2>

              <p
                v-if="overlay && !bookingConfirmed"
                class="summary-processing"
              >
                Verifying your payment and confirming your booking&hellip;
              </p>

              <template v-if="bookingConfirmed">
                <div
                  class="payment-success-panel"
                  :style="successBannerStyle"
                >
                  <div class="success-fireworks" aria-hidden="true">
                    <div class="firework-burst firework-burst--1">
                      <span style="--rot: 0deg; --delay: 0.1s; --c: #fbbf24"></span>
                      <span style="--rot: 45deg; --delay: 0.12s; --c: #34d399"></span>
                      <span style="--rot: 90deg; --delay: 0.14s; --c: #60a5fa"></span>
                      <span style="--rot: 135deg; --delay: 0.11s; --c: #f472b6"></span>
                      <span style="--rot: 180deg; --delay: 0.13s; --c: #fbbf24"></span>
                      <span style="--rot: 225deg; --delay: 0.15s; --c: #a78bfa"></span>
                      <span style="--rot: 270deg; --delay: 0.1s; --c: #34d399"></span>
                      <span style="--rot: 315deg; --delay: 0.14s; --c: #fb7185"></span>
                    </div>
                    <div class="firework-burst firework-burst--2">
                      <span style="--rot: 20deg; --delay: 0.72s; --c: #10b981"></span>
                      <span style="--rot: 65deg; --delay: 0.74s; --c: #fbbf24"></span>
                      <span style="--rot: 110deg; --delay: 0.76s; --c: #38bdf8"></span>
                      <span style="--rot: 155deg; --delay: 0.73s; --c: #f472b6"></span>
                      <span style="--rot: 200deg; --delay: 0.75s; --c: #a78bfa"></span>
                      <span style="--rot: 245deg; --delay: 0.77s; --c: #34d399"></span>
                      <span style="--rot: 290deg; --delay: 0.74s; --c: #fbbf24"></span>
                      <span style="--rot: 335deg; --delay: 0.76s; --c: #60a5fa"></span>
                    </div>
                    <div class="firework-burst firework-burst--3">
                      <span style="--rot: 10deg; --delay: 1.38s; --c: #34d399"></span>
                      <span style="--rot: 55deg; --delay: 1.4s; --c: #fbbf24"></span>
                      <span style="--rot: 100deg; --delay: 1.42s; --c: #fb7185"></span>
                      <span style="--rot: 145deg; --delay: 1.39s; --c: #60a5fa"></span>
                      <span style="--rot: 190deg; --delay: 1.41s; --c: #10b981"></span>
                      <span style="--rot: 235deg; --delay: 1.43s; --c: #fbbf24"></span>
                      <span style="--rot: 280deg; --delay: 1.4s; --c: #a78bfa"></span>
                      <span style="--rot: 325deg; --delay: 1.42s; --c: #34d399"></span>
                    </div>
                    <div class="firework-burst firework-burst--4">
                      <span style="--rot: 15deg; --delay: 1.98s; --c: #fbbf24"></span>
                      <span style="--rot: 60deg; --delay: 2s; --c: #34d399"></span>
                      <span style="--rot: 105deg; --delay: 2.02s; --c: #60a5fa"></span>
                      <span style="--rot: 150deg; --delay: 1.99s; --c: #f472b6"></span>
                      <span style="--rot: 195deg; --delay: 2.01s; --c: #a78bfa"></span>
                      <span style="--rot: 240deg; --delay: 2.03s; --c: #10b981"></span>
                      <span style="--rot: 285deg; --delay: 2s; --c: #fb7185"></span>
                      <span style="--rot: 330deg; --delay: 2.02s; --c: #fbbf24"></span>
                    </div>
                    <div class="firework-burst firework-burst--5">
                      <span style="--rot: 5deg; --delay: 2.48s; --c: #fbbf24"></span>
                      <span style="--rot: 50deg; --delay: 2.5s; --c: #34d399"></span>
                      <span style="--rot: 95deg; --delay: 2.52s; --c: #60a5fa"></span>
                      <span style="--rot: 140deg; --delay: 2.49s; --c: #f472b6"></span>
                      <span style="--rot: 185deg; --delay: 2.51s; --c: #a78bfa"></span>
                      <span style="--rot: 230deg; --delay: 2.53s; --c: #10b981"></span>
                      <span style="--rot: 275deg; --delay: 2.5s; --c: #fb7185"></span>
                      <span style="--rot: 320deg; --delay: 2.52s; --c: #fbbf24"></span>
                    </div>
                  </div>

                <div class="booking-success-banner">
                  <div class="booking-success-banner__icon-wrap">
                    <div class="booking-success-banner__icon">
                    <svg
                      class="success-checkmark"
                      viewBox="0 0 52 52"
                      aria-hidden="true"
                    >
                      <circle
                        class="success-checkmark__circle"
                        cx="26"
                        cy="26"
                        r="24"
                        fill="none"
                      />
                      <path
                        class="success-checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      />
                    </svg>
                    </div>
                  </div>
                  <h3 class="booking-success-banner__title">
                    {{ successHeadline }}
                  </h3>
                  <p class="booking-success-banner__subtitle">
                    {{ successSubheadline }}
                  </p>
                </div>

                <div class="booking-success-details booking-success-details--reveal">
                  <div class="billing-receipt">
                    <section class="billing-receipt__payment">
                      <div class="billing-receipt__payment-copy">
                        <span class="billing-receipt__eyebrow">Payment summary</span>
                        <p class="billing-receipt__amount">
                          <span class="billing-receipt__currency">AUD</span>
                          ${{ formatAmount(rate) }}
                        </p>
                        <span
                          class="payment-status-badge"
                          :class="paymentStatusClass"
                        >
                          {{ paymentStatusLabel }}
                        </span>
                      </div>
                    </section>

                    <section class="billing-receipt__section">
                      <h4 class="billing-receipt__section-title">Booking details</h4>
                      <dl class="billing-receipt__grid">
                        <div class="billing-receipt__row">
                          <dt>Booking name</dt>
                          <dd>{{ displayValue(confirmedBookingData?.BookingDetails?.BookingName) }}</dd>
                        </div>
                        <div class="billing-receipt__row">
                          <dt>Email</dt>
                          <dd>{{ displayValue(confirmedContactEmail) }}</dd>
                        </div>
                        <div class="billing-receipt__row">
                          <dt>Phone</dt>
                          <dd>{{ displayValue(confirmedContactPhone) }}</dd>
                        </div>
                      </dl>
                    </section>

                    <section class="billing-receipt__section">
                      <h4 class="billing-receipt__section-title">
                        {{ venueListForDisplay.length > 1 ? "Venues & schedule" : "Venue & schedule" }}
                      </h4>
                      <div class="billing-receipt__venues">
                        <article
                          v-for="(venue, i) in venueListForDisplay"
                          :key="`${venue.venueName}-${i}`"
                          class="venue-booking-card"
                        >
                          <h5 class="venue-booking-card__name">
                            {{ displayValue(venue.venueName) }}
                          </h5>
                          <div
                            v-if="isFulldayBooking"
                            class="session-schedule session-schedule--fullday"
                          >
                            <div class="session-schedule__slot session-schedule__slot--fullday">
                              <span class="session-schedule__label">Date</span>
                              <time class="session-schedule__datetime">
                                <span class="session-schedule__date">
                                  {{ formatDisplayDate(venue.startTime || venue.endTime) }}
                                </span>
                                <span class="session-schedule__badge">Full day</span>
                              </time>
                            </div>
                          </div>
                          <div
                            v-else
                            class="session-schedule"
                          >
                            <div class="session-schedule__slot">
                              <span class="session-schedule__label">Start</span>
                              <time class="session-schedule__datetime">
                                <span class="session-schedule__date">
                                  {{ formatDisplayDate(venue.startTime) }}
                                </span>
                                <span class="session-schedule__time">
                                  {{ formatDisplayTime(venue.startTime) }}
                                </span>
                              </time>
                            </div>
                            <div class="session-schedule__bridge" aria-hidden="true">
                              <span
                                v-if="sessionDurationLabel(venue.startTime, venue.endTime)"
                                class="session-schedule__duration"
                              >
                                {{ sessionDurationLabel(venue.startTime, venue.endTime) }}
                              </span>
                            </div>
                            <div class="session-schedule__slot">
                              <span class="session-schedule__label">End</span>
                              <time class="session-schedule__datetime">
                                <span class="session-schedule__date">
                                  {{ formatDisplayDate(venue.endTime) }}
                                </span>
                                <span class="session-schedule__time">
                                  {{ formatDisplayTime(venue.endTime) }}
                                </span>
                              </time>
                            </div>
                          </div>
                        </article>
                      </div>
                    </section>

                    <p v-if="text" class="billing-receipt__note">{{ text }}</p>
                  </div>

              <div
                class="booking-success-actions booking-success-actions--reveal"
                :style="{
                  '--action-btn-accent': buttonColor || '#2563eb',
                }"
              >
                <div class="booking-success-actions__inner">
                  <span class="booking-success-actions__eyebrow">
                    Continue booking
                  </span>
                  <p class="booking-success-actions__hint">
                    Make another reservation at a different venue or time slot.
                  </p>
                  <button
                    type="button"
                    class="booking-success-actions__btn"
                    @click="goToHomePage"
                  >
                    <span class="booking-success-actions__btn-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                        <path d="M8 7V3m8 4V3M4 11h16M6 5h12a2 2 0 012 2v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2z" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 15v3m-3-1.5h6" stroke-linecap="round"/>
                      </svg>
                    </span>
                    <span class="booking-success-actions__btn-copy">
                      <span class="booking-success-actions__btn-title">
                        Book another venue
                      </span>
                      <span class="booking-success-actions__btn-sub">
                        Return to venue selection
                      </span>
                    </span>
                    <span class="booking-success-actions__btn-arrow" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  </button>
                </div>
              </div>
                </div>
              </div>
              </template>
          </div>
        </v-col>
        <v-col cols="12">
          <v-overlay :model-value="overlay" class="align-center justify-center">
            <v-progress-circular
              :color="circleColor"
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        </v-col>
      </v-row>
      <v-dialog
        v-model="showErrorModalBox"
        persistent
        max-width="640"
        content-class="payment-alert-dialog"
      >
        <v-card class="payment-alert-modal payment-alert-modal--warning">
          <div class="payment-alert-modal__accent" aria-hidden="true"></div>
          <div class="payment-alert-modal__content">
            <div class="payment-alert-modal__icon-wrap">
              <div class="payment-alert-modal__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                  <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <h2 class="payment-alert-modal__title">{{ bookingErrorTitle }}</h2>
            <p class="payment-alert-modal__message">{{ bookingErrorMessage }}</p>
            <v-btn
              class="payment-alert-modal__btn"
              :style="{ 'background-color': buttonColor, color: 'var(--booking-button-font-color)' }"
              size="large"
              block
              @click="goToHomePage"
            >
              Go to Home Page
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showPaymentProcessedBookingPendingModal"
        persistent
        max-width="640"
        content-class="payment-alert-dialog"
      >
        <v-card class="payment-alert-modal payment-alert-modal--info">
          <div class="payment-alert-modal__accent" aria-hidden="true"></div>
          <div class="payment-alert-modal__content">
            <div class="payment-alert-modal__icon-wrap">
              <div class="payment-alert-modal__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v5m0-7h.01" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <span class="payment-alert-modal__label">Payment received</span>
            <h2 class="payment-alert-modal__title">
              Your payment has been processed
            </h2>
            <p class="payment-alert-modal__message">
              Your payment has been processed, but your booking is not yet
              confirmed. Please wait a few minutes. If you do not receive a
              booking confirmation email, please contact your venue
              administrator.
            </p>
            <p
              v-if="paymentProcessedAmount > 0"
              class="payment-alert-modal__amount"
            >
              Amount paid: AUD ${{ formatAmount(paymentProcessedAmount) }}
            </p>
            <v-btn
              class="payment-alert-modal__btn"
              :style="{ 'background-color': buttonColor, color: 'var(--booking-button-font-color)' }"
              size="large"
              block
              @click="goToHomePage"
            >
              Go to Home Page
            </v-btn>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="showPaymentDeclinedModal"
        persistent
        max-width="480"
        content-class="declined-modal-dialog"
      >
        <v-card
          :key="declinedModalKey"
          class="declined-modal"
          elevation="0"
        >
          <header class="declined-modal__header">
            <div class="declined-modal__icon-wrap">
              <svg
                class="decline-mark"
                viewBox="0 0 52 52"
                aria-hidden="true"
              >
                <circle
                  class="decline-mark__circle"
                  cx="26"
                  cy="26"
                  r="24"
                  fill="none"
                />
                <path
                  class="decline-mark__cross"
                  fill="none"
                  d="M17 17l18 18M35 17L17 35"
                />
              </svg>
            </div>
            <span class="declined-modal__badge">Declined by card issuer</span>
            <h2 class="declined-modal__title">Payment authorisation unsuccessful</h2>
            <p class="declined-modal__summary">
              Your card issuer or financial institution has declined this
              payment. Your booking has not been confirmed and no amount has
              been charged to your account.
            </p>
          </header>

          <div class="declined-modal__body">
            <section class="declined-modal__section declined-modal__section--animate">
              <h3 class="declined-modal__section-heading">
                Card issuer response
              </h3>
              <div class="declined-modal__response-card">
                <div class="declined-modal__response-row">
                  <span class="declined-modal__response-label">
                    Authorisation status
                  </span>
                  <span class="declined-modal__response-status">Not authorised</span>
                </div>
                <div class="declined-modal__response-row declined-modal__response-row--message">
                  <span class="declined-modal__response-label">
                    Decline reason
                  </span>
                  <p class="declined-modal__response-text">
                    {{ displayDeclineReason }}
                  </p>
                </div>
              </div>
            </section>

            <section class="declined-modal__section declined-modal__section--animate declined-modal__section--delay">
              <h3 class="declined-modal__section-heading">
                Recommended next steps
              </h3>
              <ul class="declined-modal__steps">
                <li class="declined-modal__step">
                  Verify your card number, expiry date, and available credit or
                  funds with your card issuer.
                </li>
                <li class="declined-modal__step">
                  Contact your bank or card issuer to confirm the transaction
                  was not blocked for security or policy reasons.
                </li>
                <li class="declined-modal__step">
                  Return to the home page to submit a new booking once the
                  matter has been resolved.
                </li>
              </ul>
            </section>
          </div>

          <footer class="declined-modal__footer declined-modal__footer--animate">
            <v-btn
              class="declined-modal__btn"
              :style="{ 'background-color': buttonColor, color: 'var(--booking-button-font-color)' }"
              size="large"
              block
              @click="goToHomePage"
            >
              Return to home page
            </v-btn>
          </footer>
        </v-card>
      </v-dialog>
    </v-container>
    <footer-component />
  </div>
</template>

<script>
import { getResult, confirmBooking } from "../../../../server/config";
import HeaderComponent from "@/components/common/HeaderComponent/index.vue";
import {
  clearOtpSession,
  deductOtpBookingHours,
  getOtpPaymentTxnDetail,
  isOtpBookingCheckout,
} from "@/utils/otpSession.js";
// OLD FLOW (disabled): stepper tick icons
// import TickMark from "../../../assets/tickMark.vue";
import {
  getBookingGeneral,
  getBookingDetailSettings,
} from "../../../store/vuexStore";
import * as ENV from "@/config.js";
import { applyBookingTheme } from "@/utils/bookingTheme.js";

export default {
  components: { HeaderComponent },
  data() {
    return {
      storeResultKey: "",
      storeVenueDetails: [],
      confirmedBookingData: null,
      BookingName: "",
      rate: "",
      venueName: "",
      singleBooking: false,
      overlay: false,
      facility: ENV.VUE_APP_FACILITY,
      showErrorModalBox: false,
      showPaymentProcessedBookingPendingModal: false,
      paymentProcessedAmount: 0,
      showPaymentDeclinedModal: false,
      declinedModalKey: 0,
      paymentDeclinedMessage: "",
      bookingErrorTitle: "Booking could not be completed",
      bookingErrorMessage:
        "Go back to the home page and start a new booking.",
      disableORenable2ndDetailPage: "",
      text: "",
      statusbar: 100,
      buttonColor: "",
      bookingType: sessionStorage.getItem("BookingType"),
      isFreeBooking: sessionStorage.getItem("isFreeBooking"),
      paymentSuccess: false,
      selectedVenueUniqueId: sessionStorage.getItem("selectedVenueUniqueId") || "",
      isFulldayBooking: sessionStorage.getItem("isFulldayBooking") === "true",
      multiBookingOriginalTimes: [],
      confirmedVenueBlockIds: null,
      confirmedContactSnapshot: null,
      otpBookingConfirmed: false,
      otpHoursRemainingSnapshot: null,
    };
  },

  computed: {
    bookingConfirmed() {
      return (
        this.confirmedBookingData != null && this.storeVenueDetails.length > 0
      );
    },
    paymentStatusLabel() {
      if (this.otpBookingConfirmed || this.isFreeBooking === "true") {
        return "Not required";
      }
      return this.paymentSuccess ? "Successful" : "Unsuccessful";
    },
    paymentStatusClass() {
      if (this.otpBookingConfirmed || this.isFreeBooking === "true") {
        return "payment-status-badge--neutral";
      }
      return this.paymentSuccess
        ? "payment-status-badge--success"
        : "payment-status-badge--fail";
    },
    displayDeclineReason() {
      const message = (this.paymentDeclinedMessage || "").trim();
      if (message) {
        return message;
      }
      return "The card issuer or bank did not authorise this transaction. Please contact your financial institution for further information.";
    },
    successAccentColor() {
      const green = "#059669";
      if (this.buttonColor && !this.isGreyishColor(this.buttonColor)) {
        return this.buttonColor;
      }
      return green;
    },
    successBannerStyle() {
      const accent = this.successAccentColor;
      return {
        "--success-color": accent,
        "--success-soft": "#ecfdf5",
        "--success-mid": "#d1fae5",
        "--success-deep": "#10b981",
      };
    },
    successHeadline() {
      if (this.otpBookingConfirmed || this.isFreeBooking === "true") {
        return "Booking confirmed";
      }
      if (this.paymentSuccess) {
        return "Payment successful";
      }
      return "Booking confirmed";
    },
    successSubheadline() {
      if (this.otpBookingConfirmed) {
        return this.otpHoursRemainingSnapshot != null
          ? `Your complimentary OTP booking is confirmed. You have ${this.otpHoursRemainingSnapshot} hour(s) remaining.`
          : "Your complimentary OTP booking is confirmed. A confirmation email will be sent to you shortly.";
      }
      if (this.isFreeBooking === "true") {
        return "Your reservation has been successfully confirmed.";
      }
      if (this.paymentSuccess) {
        return "Your payment was approved. A confirmation email will be sent to you shortly.";
      }
      return "Your booking has been successfully confirmed.";
    },
    confirmedContactDetails() {
      const fromConfirmation = this.confirmedBookingData?.BookingDetails || {};
      const fromSnapshot = this.confirmedContactSnapshot || {};
      const fromContext = this.loadPaymentCheckoutContext()?.contact || {};
      let fromSession = {};

      try {
        const raw = sessionStorage.getItem("bookingWizardContact");
        fromSession = raw ? JSON.parse(raw) : {};
      } catch {
        fromSession = {};
      }

      return {
        email:
          fromConfirmation.Email ||
          fromSnapshot.email ||
          fromContext.Email ||
          fromSession.Email ||
          sessionStorage.getItem("email") ||
          "",
        phone:
          fromConfirmation.Phone ||
          fromSnapshot.phone ||
          fromContext.Phone ||
          fromSession.Phone ||
          "",
      };
    },
    confirmedContactEmail() {
      return this.confirmedContactDetails.email;
    },
    confirmedContactPhone() {
      return this.confirmedContactDetails.phone;
    },
    venueListForDisplay() {
      if (this.singleBooking) {
        return this.storeVenueDetails.map((booking) => {
          const venueDetail = booking.venueDetails?.[0] || {};
          return {
            venueName: venueDetail.venueName,
            eventNumber:
              booking.eventDetails || this.extractEventNumber(booking),
            startTime: this.getSingleBookingStartTime(venueDetail),
            endTime: this.getSingleBookingEndTime(venueDetail),
          };
        });
      }

      const venues = this.storeVenueDetails[0] || [];
      return venues.map((booking, index) => ({
        venueName: booking.venueName,
        eventNumber:
          this.extractEventNumber(booking) ||
          this.extractEventNumber(this.confirmedBookingData),
        startTime: this.getOriginalStartTime(booking, index),
        endTime: this.getOriginalEndTime(booking, index),
      }));
    },
  },

  created() {
    const storedVenueId = sessionStorage.getItem("selectedVenueUniqueId");
    if (storedVenueId && storedVenueId !== "0" && storedVenueId !== 0) {
      this.selectedVenueUniqueId = String(storedVenueId).trim();
    }

    // Load original times for multi-booking
    const storedOriginalTimes = sessionStorage.getItem("multiBookingOriginalTimes");
    if (storedOriginalTimes) {
      try {
        this.multiBookingOriginalTimes = JSON.parse(storedOriginalTimes);
      } catch (e) {
        this.multiBookingOriginalTimes = [];
      }
    }

    // Fetching data from vuex store
    const bookingGeneral = getBookingGeneral() || {};
    applyBookingTheme(bookingGeneral);
    this.circleColor = bookingGeneral.color;
    this.buttonColor = bookingGeneral.buttoncolor;
    // Summary text for each Venue
    this.text = sessionStorage.getItem(
      "selectedVenueSummary",
      getBookingGeneral().text.text
    );
    this.disableORenable2ndDetailPage = getBookingDetailSettings()[0]?.isActive;

    // if (this.isFreeBooking == "false") {
    //   var myParam = location.search.split("ResultKey=")[1];
    //   this.storeResultKey = myParam.substring(0, myParam.length - 1);
    //   this.getResultKey();
    // } else {
    //   this.processFreeBooking();
    // }
  },
  mounted() {
    if (isOtpBookingCheckout()) {
      this.processOtpBooking();
      return;
    }

    if (this.isFreeBooking == "false") {
      const params = new URLSearchParams(window.location.search);
      this.storeResultKey =
        params.get("ResultKey") || params.get("resultKey") || "";
      if (this.storeResultKey) {
        this.getResultKey(this.storeResultKey);
      } else {
        this.showPaymentVerificationError();
      }
    } else {
      this.processFreeBooking();
    }
  },
  methods: {
    isGreyishColor(color) {
      if (!color || typeof color !== "string") return true;
      const hex = color.replace("#", "").trim();
      if (hex.length !== 6 || !/^[0-9a-f]{6}$/i.test(hex)) return false;
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      return Math.max(r, g, b) - Math.min(r, g, b) < 28;
    },
    goToHomePage() {
      this.showPaymentDeclinedModal = false;
      this.showErrorModalBox = false;
      this.showPaymentProcessedBookingPendingModal = false;
      this.$router.push({ path: `/bookingapp/${this.facility}/` });
    },

    getVenueBlockId() {
      try {
        const raw = sessionStorage.getItem("venueBlockId");
        if (!raw) {
          return null;
        }
        return JSON.parse(raw);
      } catch (error) {
        return null;
      }
    },

    formatVenueBlockIds(venueBlockId) {
      if (venueBlockId == null) {
        return null;
      }

      let ids = venueBlockId;
      if (
        ids &&
        typeof ids === "object" &&
        !Array.isArray(ids) &&
        ids.venueblockid != null
      ) {
        ids = ids.venueblockid;
      }

      if (Array.isArray(ids)) {
        const normalized = ids
          .map((id) => String(id).trim())
          .filter(Boolean);
        return normalized.length ? normalized.join(", ") : null;
      }

      const text = String(ids).trim();
      return text || null;
    },

    captureVenueBlockIds() {
      if (this.confirmedVenueBlockIds != null) {
        return;
      }
      this.confirmedVenueBlockIds = this.getVenueBlockId();
    },

    getPaymentAmount(txnResponse) {
      const amount = Number(txnResponse?.amount);
      return Number.isFinite(amount) ? amount / 100 : 0;
    },

    showBookingError(title, message) {
      this.bookingErrorTitle = title;
      this.bookingErrorMessage = message;
      this.showErrorModalBox = true;
    },

    isBookingFailureStatus(status) {
      if (!status || typeof status !== "string") {
        return false;
      }
      const normalized = status.toUpperCase();
      return (
        normalized.includes("BOOKING FAILED") ||
        normalized.includes("BOOKING NOT CONFIRMED")
      );
    },

    showPaymentApprovedBookingNotConfirmed(paidAmount = 0) {
      this.paymentSuccess = true;
      this.paymentProcessedAmount = paidAmount;
      this.showErrorModalBox = false;
      this.showPaymentDeclinedModal = false;
      this.showPaymentProcessedBookingPendingModal = true;

      sessionStorage.removeItem("venueBlockId");
      sessionStorage.removeItem("paymentCheckoutContext");
      sessionStorage.removeItem("wizardPaymentStarted");
      this.clearOTPUserVerification();
    },

    showPaymentVerificationError() {
      this.paymentSuccess = false;
      this.showBookingError(
        "Unable to verify payment",
        "We could not verify your payment result. If you completed a payment, please contact your venue administrator before trying again."
      );
    },

    isPaymentApproved(txnResponse) {
      if (!txnResponse) {
        return false;
      }
      const code = txnResponse.responseCode;
      return code === "0" || code === 0;
    },

    formatAmount(value) {
      const n = parseFloat(value);
      return (Number.isNaN(n) ? 0 : n).toFixed(2);
    },
    displayValue(value, fallback = "—") {
      if (value === null || value === undefined || String(value).trim() === "") {
        return fallback;
      }
      return value;
    },

    extractEventNumber(source) {
      if (source == null) {
        return null;
      }

      if (typeof source === "string" || typeof source === "number") {
        const text = String(source).trim();
        return text === "" ? null : text;
      }

      const eventDetails = source.EventDetails ?? source.eventDetails;
      if (eventDetails != null) {
        if (typeof eventDetails === "string" || typeof eventDetails === "number") {
          const text = String(eventDetails).trim();
          if (text) {
            return text;
          }
        }

        const result = eventDetails.result ?? eventDetails.Result ?? eventDetails;
        if (Array.isArray(result)) {
          const numbers = result
            .map((item) => this.extractEventNumber(item))
            .filter(Boolean);
          if (numbers.length) {
            return [...new Set(numbers)].join(", ");
          }
        }

        if (result && typeof result === "object") {
          const nested =
            result.EventNumber ??
            result.eventNumber ??
            result.EventNo ??
            result.eventNo ??
            result.Number ??
            result.number;
          if (nested != null && String(nested).trim() !== "") {
            return String(nested).trim();
          }
        }
      }

      const direct =
        source.EventNumber ??
        source.eventNumber ??
        source.EventNo ??
        source.eventNo ??
        source.eventDetails;
      if (direct != null && String(direct).trim() !== "") {
        return String(direct).trim();
      }

      const venueLists = [source.venueDetails, source.VenueDetails];
      for (const venues of venueLists) {
        if (!Array.isArray(venues)) {
          continue;
        }
        for (const venue of venues) {
          const fromVenue = this.extractEventNumber(venue);
          if (fromVenue) {
            return fromVenue;
          }
        }
      }

      return null;
    },

    formatDisplayDate(value) {
      const raw = this.displayValue(value, null);
      if (!raw) {
        return "—";
      }

      const { date } = this.extractDateAndTime(raw);
      return date || raw;
    },

    formatDisplayTime(value) {
      const raw = this.displayValue(value, null);
      if (!raw) {
        return "—";
      }

      const { time } = this.extractDateAndTime(raw);
      const timePart = time || raw;

      if (/am|pm/i.test(String(timePart))) {
        return timePart;
      }

      const match = String(timePart).match(/^(\d{1,2}):(\d{2})/);
      if (!match) {
        return timePart;
      }

      let hours = parseInt(match[1], 10);
      const minutes = match[2];
      const period = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      if (hours === 0) {
        hours = 12;
      }
      return `${hours}:${minutes} ${period}`;
    },

    parseTimeToMinutes(value) {
      if (!value) {
        return null;
      }
      const { time } = this.extractDateAndTime(value);
      const timePart = time || value;
      const match = String(timePart).match(/^(\d{1,2}):(\d{2})/);
      if (!match) {
        return null;
      }
      return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
    },

    sessionDurationLabel(start, end) {
      const startMinutes = this.parseTimeToMinutes(start);
      const endMinutes = this.parseTimeToMinutes(end);
      if (startMinutes == null || endMinutes == null || endMinutes <= startMinutes) {
        return "";
      }

      const diff = endMinutes - startMinutes;
      const hours = Math.floor(diff / 60);
      const minutes = diff % 60;

      if (hours && minutes) {
        return `${hours} hr ${minutes} min`;
      }
      if (hours === 1) {
        return "1 hour";
      }
      if (hours > 1) {
        return `${hours} hours`;
      }
      return `${minutes} min`;
    },
    clearOTPUserVerification() {
      clearOtpSession();
    },
    
    async processOtpBooking() {
      this.singleBooking = true;
      this.overlay = true;
      this.showPaymentDeclinedModal = false;
      this.showErrorModalBox = false;
      this.paymentSuccess = true;

      const venueBlockId = this.getVenueBlockId();
      if (!venueBlockId) {
        this.showBookingError(
          "Booking could not be completed",
          "Booking details were not found. Please return to the home page and start again."
        );
        this.overlay = false;
        return;
      }

      this.captureVenueBlockIds();
      this.captureConfirmedContactSnapshot();

      try {
        const confirmationResponse = await confirmBooking(
          venueBlockId,
          getOtpPaymentTxnDetail(),
          this.bookingType
        );

        const hoursUsed = Number(sessionStorage.getItem("otpBookingHoursUsed") || 0);
        if (hoursUsed > 0) {
          this.otpHoursRemainingSnapshot = deductOtpBookingHours(hoursUsed);
        }
        this.otpBookingConfirmed = true;
        sessionStorage.removeItem("otpBookingHoursUsed");
        sessionStorage.removeItem("isOtpBooking");

        this.applyConfirmationResults(confirmationResponse, 0);
      } catch (error) {
        this.showBookingError(
          "Booking could not be completed",
          "We were unable to confirm your complimentary OTP booking. Please contact your venue administrator."
        );
      } finally {
        this.overlay = false;
      }
    },

    async processFreeBooking() {
      this.singleBooking = true;
      this.overlay = true;
      this.showPaymentDeclinedModal = false;
      this.showErrorModalBox = false;

      const venueBlockId = this.getVenueBlockId();
      if (!venueBlockId) {
        this.showBookingError(
          "Booking could not be completed",
          "Booking details were not found. Please return to the home page and start again."
        );
        this.overlay = false;
        return;
      }

      this.captureVenueBlockIds();
      this.captureConfirmedContactSnapshot();

      try {
        const confirmationResponse = await confirmBooking(
          venueBlockId,
          null,
          this.bookingType
        );
        this.applyConfirmationResults(confirmationResponse, 0);
      } catch (error) {
        this.showBookingError(
          "Booking could not be completed",
          "We were unable to confirm your booking. Please return to the home page and try again."
        );
      } finally {
        this.overlay = false;
      }
    },

    captureConfirmedContactSnapshot() {
      if (this.confirmedContactSnapshot) {
        return;
      }

      const context = this.loadPaymentCheckoutContext();
      let fromSession = {};

      try {
        const raw = sessionStorage.getItem("bookingWizardContact");
        fromSession = raw ? JSON.parse(raw) : {};
      } catch {
        fromSession = {};
      }

      this.confirmedContactSnapshot = {
        email:
          context?.contact?.Email ||
          fromSession.Email ||
          sessionStorage.getItem("email") ||
          "",
        phone: context?.contact?.Phone || fromSession.Phone || "",
      };
    },

    applyConfirmationResults(confirmationResponse, paidAmount) {
      if (!Array.isArray(confirmationResponse) || confirmationResponse.length === 0) {
        if (paidAmount > 0) {
          this.showPaymentApprovedBookingNotConfirmed(paidAmount);
        } else {
          this.paymentSuccess = false;
          this.showBookingError(
            "Booking could not be completed",
            "No booking confirmation was returned. Please return to the home page and try again."
          );
        }
        return;
      }

      let confirmed = false;
      let bookingFailedAfterPayment = false;

      this.captureVenueBlockIds();

      for (let index = 0; index < confirmationResponse.length; index++) {
        const element = confirmationResponse[index];
        if (
          element.status === "PAYMENT SUCCESS, BOOKING FAILED" ||
          this.isBookingFailureStatus(element.status)
        ) {
          bookingFailedAfterPayment = true;
          continue;
        }

        if (
          this.bookingType === "singlebooking" ||
          this.bookingType === "bundlebooking"
        ) {
          this.singleBooking = true;
          this.storeVenueDetails.push({
            venueDetails: element.VenueDetails,
            eventDetails: this.extractEventNumber(element),
          });
        } else if (this.bookingType === "multibooking") {
          this.singleBooking = false;
          const venueDetailsWithOriginalTimes = (element.VenueDetails || []).map(
            (venueDetail, idx) => this.mergeOriginalBookingTimes(venueDetail, idx)
          );
          this.storeVenueDetails.push(venueDetailsWithOriginalTimes);
        } else {
          this.paymentSuccess = false;
          this.showBookingError(
            "Booking could not be completed",
            "An unsupported booking type was detected. Please return to the home page and try again."
          );
          return;
        }

        sessionStorage.removeItem("venueBlockId");
        this.confirmedBookingData = element;
        this.rate = paidAmount;
        confirmed = true;
      }

      if (confirmed) {
        this.captureConfirmedContactSnapshot();
        sessionStorage.removeItem("paymentCheckoutContext");
        sessionStorage.removeItem("wizardPaymentStarted");
        this.clearOTPUserVerification();
      } else if (bookingFailedAfterPayment || paidAmount > 0) {
        this.showPaymentApprovedBookingNotConfirmed(paidAmount);
      }
    },

    mergeOriginalBookingTimes(venueDetail, idx) {
      let originalTime = null;

      if (idx < this.multiBookingOriginalTimes.length) {
        const candidate = this.multiBookingOriginalTimes[idx];
        if (candidate && candidate.StartTime && venueDetail.StartTime) {
          const candidateDate = this.extractDateAndTime(candidate.StartTime).date;
          const apiDate = this.extractDateAndTime(venueDetail.StartTime).date;
          if (candidateDate === apiDate) {
            originalTime = candidate;
          }
        }
        if (!originalTime && candidate) {
          originalTime = candidate;
        }
      }

      if (
        !originalTime &&
        venueDetail.StartTime &&
        venueDetail.VenueId &&
        this.multiBookingOriginalTimes.length > 0
      ) {
        const apiDateTime = this.extractDateAndTime(venueDetail.StartTime);
        originalTime = this.multiBookingOriginalTimes.find((ot) => {
          if (!ot.StartTime) return false;
          const originalDateTime = this.extractDateAndTime(ot.StartTime);
          return (
            originalDateTime.date === apiDateTime.date &&
            ot.VenueId &&
            ot.VenueId.toString() === venueDetail.VenueId.toString()
          );
        });
      }

      if (
        !originalTime &&
        venueDetail.StartTime &&
        venueDetail.venueName &&
        this.multiBookingOriginalTimes.length > 0
      ) {
        const apiDateTime = this.extractDateAndTime(venueDetail.StartTime);
        originalTime = this.multiBookingOriginalTimes.find((ot) => {
          if (!ot.StartTime) return false;
          const originalDateTime = this.extractDateAndTime(ot.StartTime);
          return (
            originalDateTime.date === apiDateTime.date &&
            ot.venueName.trim().toLowerCase() ===
              venueDetail.venueName.trim().toLowerCase()
          );
        });
      }

      if (originalTime) {
        return {
          ...venueDetail,
          displayStartTime: originalTime.StartTime,
          displayEndTime: originalTime.EndTime,
        };
      }

      return venueDetail;
    },

    hydrateFromPaymentCheckoutContext() {
      const context = this.loadPaymentCheckoutContext();
      if (!context) {
        return;
      }

      if (!this.getVenueBlockId()) {
        if (context.venueBlockId) {
          sessionStorage.setItem(
            "venueBlockId",
            JSON.stringify(context.venueBlockId)
          );
        } else if (
          context.storeVenueBlockId != null &&
          context.storeVenueBlockId !== ""
        ) {
          sessionStorage.setItem(
            "venueBlockId",
            JSON.stringify(context.storeVenueBlockId)
          );
        }
      }

      if (context.bookingType) {
        this.bookingType = context.bookingType;
        if (!sessionStorage.getItem("BookingType")) {
          sessionStorage.setItem("BookingType", context.bookingType);
        }
      }
      if (context.isFreeBooking) {
        this.isFreeBooking = context.isFreeBooking;
      }
      if (context.isFulldayBooking != null) {
        this.isFulldayBooking =
          context.isFulldayBooking === true ||
          context.isFulldayBooking === "true";
        sessionStorage.setItem(
          "isFulldayBooking",
          String(this.isFulldayBooking)
        );
      }
      if (context.venueId) {
        this.selectedVenueUniqueId = context.venueId;
      }
    },

    loadPaymentCheckoutContext() {
      try {
        const raw = sessionStorage.getItem("paymentCheckoutContext");
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    },

    isValidVenueBlockId(value) {
      if (value == null || value === "") {
        return false;
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return true;
    },

    resolveVenueBlockIdForConfirmation() {
      const fromSession = this.getVenueBlockId();
      if (this.isValidVenueBlockId(fromSession)) {
        return fromSession;
      }

      const context = this.loadPaymentCheckoutContext() || {};
      if (this.isValidVenueBlockId(context.venueBlockId)) {
        return context.venueBlockId;
      }

      if (this.isValidVenueBlockId(context.storeVenueBlockId)) {
        return context.storeVenueBlockId;
      }

      return null;
    },

    getPaymentConfirmationContext() {
      let venueBlockId = this.resolveVenueBlockIdForConfirmation();
      if (venueBlockId) {
        sessionStorage.setItem("venueBlockId", JSON.stringify(venueBlockId));
      }

      const bookingType =
        this.bookingType ||
        this.loadPaymentCheckoutContext()?.bookingType ||
        sessionStorage.getItem("BookingType") ||
        "singlebooking";

      return { venueBlockId, bookingType };
    },

    async submitPaymentResult(txnResponse) {
      const { venueBlockId, bookingType } = this.getPaymentConfirmationContext();
      if (!venueBlockId) {
        return null;
      }

      this.captureVenueBlockIds();
      return confirmBooking(venueBlockId, txnResponse, bookingType);
    },

    async confirmPaidBooking(txnResponse) {
      const { venueBlockId } = this.getPaymentConfirmationContext();
      if (!venueBlockId) {
        this.paymentSuccess = false;
        this.showBookingError(
          "Booking could not be completed",
          "Booking details were not found after payment. Please contact your venue administrator."
        );
        return;
      }

      try {
        const confirmationResponse = await this.submitPaymentResult(txnResponse);
        this.applyConfirmationResults(
          confirmationResponse,
          this.getPaymentAmount(txnResponse)
        );
      } catch (error) {
        this.paymentSuccess = false;
        this.showBookingError(
          "Booking could not be completed",
          "Your payment was approved but we could not confirm the booking. Please contact your venue administrator."
        );
      }
    },
    async getResultKey(resultKey) {
      this.overlay = true;
      this.showPaymentDeclinedModal = false;
      this.showErrorModalBox = false;
      this.showPaymentProcessedBookingPendingModal = false;
      this.hydrateFromPaymentCheckoutContext();

      try {
        const response = await getResult(resultKey);
        const txnResponse = response?.response;

        if (!this.isPaymentApproved(txnResponse)) {
          this.paymentSuccess = false;
          this.paymentDeclinedMessage =
            txnResponse?.responseText || txnResponse?.message || "";
          try {
            await this.submitPaymentResult(txnResponse);
          } catch (error) {
            // Backend notification failed; still show decline UI.
          }
          this.declinedModalKey += 1;
          this.showPaymentDeclinedModal = true;
          return;
        }

        this.paymentSuccess = true;
        await this.confirmPaidBooking(txnResponse);
      } catch (error) {
        this.paymentSuccess = false;
        this.showPaymentVerificationError();
      } finally {
        this.overlay = false;
      }
    },
    getVenueId(storedId, bookingVenueId) {
      if (storedId && storedId !== "0" && storedId !== 0) {
        return String(storedId).trim();
      }
      if (bookingVenueId && bookingVenueId !== 0 && bookingVenueId !== "0") {
        return String(bookingVenueId).trim();
      }
      return storedId || "";
    },
    // Helper to extract date and time from a datetime string
    extractDateAndTime(dateTimeStr) {
      if (!dateTimeStr) return { date: null, time: null };
      // Handle format "DD/MM/YYYY HH:mm" or "DD/MM/YYYY HH:mm:ss"
      const parts = dateTimeStr.split(' ');
      if (parts.length < 2) return { date: null, time: null };
      return {
        date: parts[0], // "DD/MM/YYYY"
        time: parts[1].substring(0, 5) // "HH:mm" (first 5 chars to ignore seconds if present)
      };
    },
    
    getOriginalStartTime(booking, index) {
      if (booking.displayStartTime) {
        return booking.displayStartTime;
      }

      if (this.bookingType === "multibooking" && this.multiBookingOriginalTimes && this.multiBookingOriginalTimes.length > 0) {
        let originalTime = null;

        if (booking.StartTime && booking.venueName) {
          const apiDateTime = this.extractDateAndTime(booking.StartTime);
          originalTime = this.multiBookingOriginalTimes.find(ot => {
            if (!ot.StartTime || !ot.venueName) return false;
            const originalDateTime = this.extractDateAndTime(ot.StartTime);
            return originalDateTime.date === apiDateTime.date &&
                   ot.venueName.trim() === booking.venueName.trim();
          });
        }

        if (!originalTime && booking.StartTime) {
          const apiDateTime = this.extractDateAndTime(booking.StartTime);
          originalTime = this.multiBookingOriginalTimes.find(ot => {
            if (!ot.StartTime) return false;
            const originalDateTime = this.extractDateAndTime(ot.StartTime);
            return originalDateTime.date === apiDateTime.date;
          });
        }

        if (!originalTime && booking.venueName) {
          originalTime = this.multiBookingOriginalTimes.find(
            ot => ot.venueName && ot.venueName.trim() === booking.venueName.trim()
          );
        }

        if (!originalTime && index < this.multiBookingOriginalTimes.length) {
          originalTime = this.multiBookingOriginalTimes[index];
        }

        if (originalTime?.StartTime) {
          return originalTime.StartTime;
        }
      }

      return booking.displayStartTime || booking.StartTime || "";
    },
    getOriginalEndTime(booking, index) {
      if (booking.displayEndTime) {
        return booking.displayEndTime;
      }

      if (this.bookingType === "multibooking" && this.multiBookingOriginalTimes && this.multiBookingOriginalTimes.length > 0) {
        let originalTime = null;

        if (booking.StartTime && booking.venueName) {
          const apiDateTime = this.extractDateAndTime(booking.StartTime);
          originalTime = this.multiBookingOriginalTimes.find(ot => {
            if (!ot.StartTime || !ot.venueName) return false;
            const originalDateTime = this.extractDateAndTime(ot.StartTime);
            return originalDateTime.date === apiDateTime.date &&
                   ot.venueName.trim() === booking.venueName.trim();
          });
        }

        if (!originalTime && booking.StartTime) {
          const apiDateTime = this.extractDateAndTime(booking.StartTime);
          originalTime = this.multiBookingOriginalTimes.find(ot => {
            if (!ot.StartTime) return false;
            const originalDateTime = this.extractDateAndTime(ot.StartTime);
            return originalDateTime.date === apiDateTime.date;
          });
        }

        if (!originalTime && booking.venueName) {
          originalTime = this.multiBookingOriginalTimes.find(
            ot => ot.venueName && ot.venueName.trim() === booking.venueName.trim()
          );
        }

        if (!originalTime && index < this.multiBookingOriginalTimes.length) {
          originalTime = this.multiBookingOriginalTimes[index];
        }

        if (originalTime?.EndTime) {
          return originalTime.EndTime;
        }
      }

      return booking.displayEndTime || booking.EndTime || "";
    },

    // Helper methods for single booking times (use original times from sessionStorage)
    getSingleBookingStartTime(venueDetail) {
      if (!venueDetail) return "";

      const originalStartTime = sessionStorage.getItem("starttime");
      if (originalStartTime) {
        return originalStartTime;
      }

      const context = this.loadPaymentCheckoutContext();
      if (context?.startTime) {
        return context.startTime;
      }

      return venueDetail.displayStartTime || venueDetail.StartTime || "";
    },

    getSingleBookingEndTime(venueDetail) {
      if (!venueDetail) return "";

      const originalEndTime = sessionStorage.getItem("endtime");
      if (originalEndTime) {
        return originalEndTime;
      }

      const context = this.loadPaymentCheckoutContext();
      if (context?.endTime) {
        return context.endTime;
      }

      return venueDetail.displayEndTime || venueDetail.EndTime || "";
    },
  },
};
</script>
<style src="./summary.css"></style>
